(function (){
    'use strict';
    angular.module('app')
    .controller('AdministrationTeamDetailsController', function(
        $scope,
        $location,
        $routeParams,
        ActionlogTableService,
        AdminPermissionService
    ){
       $scope.admin = []
        $scope.goBack = function(){
            $location.path('administration/team-actions')
        }

        init();

        function init(){
            $scope.tableData = new ActionlogTableService().tableData;
            getuserDetails()
        }

        function getuserDetails(){
            
            AdminPermissionService.AdminCurrentUser.getAdminUserDetails(
                res=>{
                    angular.forEach(res.content,function(item){
                        $scope.admin.active = item.user.active;
                        $scope.admin.email = item.user.email;
                        $scope.admin.employeeId = item.employeeId;
                        $scope.admin.staffMember = item.user.firstName + ' '+ item.user.lastName;
                        $scope.admin.modules = item.modules;
                        $scope.admin.phone1 = item.user.company.phone1;
                       $scope.admin.permissionGroup = item.user.permissionGroup.roles;
                    })
                },
                err=>{
                    console.log(err)
                },
                $routeParams.accountId
            )
        }

    });
})();


// WEBPACK FOOTER //
// ./js/controllers/administration/AdministrationTeamDetailsController.js